import * as Yup from "yup";

const PHONE_REGEX = /^(\+1[-\s]?)?(\(?\d{3}\)?[-\s]?)\d{3}[-\s]?\d{4}$/;
const EMAIL_REGEX = /^[A-Z0-9._-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
const TEXT_ONLY_REGEX = /^[A-Za-z\s]+$/;

export const addSubUserInitialValues = {
  firstName: "",
  lastName: "",
  email: "",
  phoneNumber: "",
  jobTitle: "",
};

export const addSubUserValidationSchema = Yup.object({
  firstName: Yup.string()
    .trim()
    .max(50, "First name must be 50 characters or less")
    .required("First name is required"),
  lastName: Yup.string()
    .trim()
    .max(50, "Last name must be 50 characters or less")
    .required("Last name is required"),
  email: Yup.string()
    .trim()
    .matches(EMAIL_REGEX, "Invalid email address")
    .required("Email ID is required"),
  phoneNumber: Yup.string()
    .trim()
    .max(25, "Phone number is too long")
    .test(
      "phone-format",
      "Phone number is either invalid or in the wrong format",
      (value) => !value || value === "-" || PHONE_REGEX.test(value)
    ),
  jobTitle: Yup.string()
    .trim()
    .max(100, "Job title must be 100 characters or less")
    .test(
      "text-only",
      "Job title can only contain text characters",
      (value) => !value || TEXT_ONLY_REGEX.test(value)
    ),
});
